import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { EmptyRecRepFilter, Filter, IRevenueRepFilter } from "../Filter";
import { Fetch, ILazyParams } from "../../../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { ProjectRevenueDetails } from "./ProjectRevenueDetails";
import { Rating } from "./Rating";
import { ILogin } from "../../../../models/Login";

interface IProps {
    toast: any
}

interface IRecruiterHeadRevenueReport {
    login_ID?: number,
    user_Employee_ID?: string,
    user_Name?: string,
    branchName?: string,
    company_Name?: string,
    monthly_CTC?: number,
    seating_Cost?: number,
    incentive?: number,
    noOfECI?: number,
    noOfPO?: number,
    recruiters_Monthly_CTC?: number,
    recruiters_Seating_Cost?: number,
    recruiters_Incentive?: number,
    recruiters_Revenues?: number,
    recruiters_Rev_P_L?: number,
    projected_Recruiters_Revenues?: number,
    projected_Recruiters_Incentive?: number,
    projected_Recruiters_Monthly_CTC?: number,
    projected_Recruiters_Seating_Cost?: number,
    recruiters_Proj_Rev_P_L?: number,
    total: number,
}

export const Table = (props: IProps) => {
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRecruiterHeadRevenueReport>, loading: boolean });
    const [revenueFilter, setRevenueFilter] = useState<IRevenueRepFilter>(EmptyRecRepFilter);
    const [openProjectRevenueDetails, setOpenProjectRevenueDetails] = useState({ open: false, user_Employee_ID: '' } as { open: boolean, user_Employee_ID: string });

    const dt = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    loginObj.roles.forEach((role) => {
        _roles.push(role.role_ID);
    });

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'login_ID',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const header = () => <p>Revenue Report</p>;

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Report_Revenue/getRecruiterHeadRevenueReport", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(revenueFilter)}`, props.toast);
        if (response) {
            const data: Array<IRecruiterHeadRevenueReport> = await response.json();
            if (data.length > 0) setTotalRecords(data[0].total || 0);
            else setTotalRecords(0);
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    // const projectRevenue = (rowData: IRecruiterHeadRevenueReport) => {
    //     return <p onClick={() => {
    //         if (rowData.projected_Revenue && rowData.projected_Revenue > 0) {
    //             setOpenProjectRevenueDetails({ open: true, user_Employee_ID: (rowData.user_Employee_ID || '') });
    //         } else props.toast.current.show({ severity: 'info', detail: 'No Projected Revenue Details To Show', life: 3000 });
    //     }} className="cursor-pointer text-cyan-700 underline">₹ {parseInt(`${rowData.projected_Revenue}`)}</p>;
    // }

    // const projectRevenuePL = (rowData: IRecruiterHeadRevenueReport) => {
    //     return <p style={{ color: ((rowData.projected_Revenue || 0) < ((rowData.project_Rev_PL_Amnt || 0) + (rowData.approxProjRevM_Salary || 0) + (rowData.approxProjSeating_Cost || 0))) ? "red" : "green" }}>₹ {parseInt(`${(rowData.projected_Revenue || 0) - ((rowData.project_Rev_PL_Amnt || 0) + (rowData.approxProjRevM_Salary || 0) + (rowData.approxProjSeating_Cost || 0))}`)}</p>;
    // }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <div className="my-2">
                    <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData()} />
                </div>
            </>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                {(_roles.includes(1) || _roles.includes(12)) && <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />}
            </>
        );
    };

    useEffect(() => {
        loadTableData();
    }, [lazyParams, revenueFilter]);

    // ₹

    return (
        <>
            <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3" />
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter revenueFilter={revenueFilter} setRevenueFilter={setRevenueFilter} showNormalUsers={false} showRecHeadUsers={true} showSalesHeadUsers={false} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                lazy dataKey="login_ID" responsiveLayout="scroll"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="user_Employee_ID" header="Employee ID" />
                <Column field="user_Name" header="Name" />
                <Column field="company_Name" header="Company" />
                <Column field="branchName" header="Branch" />
                <Column field="monthly_CTC" header="Monthly CTC" />
                <Column field="seating_Cost" header="Seating Cost" />
                <Column field="incentive" header="Incentive" />
                <Column field="noOfECI" header="ECI" />
                <Column field="noOfPO" header="PO" />
                <Column field="recruiters_Monthly_CTC" header="Recruiters Monthly CTC" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.recruiters_Monthly_CTC}`)}</p>} />
                <Column field="recruiters_Seating_Cost" header="Recruiters Seating Cost" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.recruiters_Seating_Cost}`)}</p>} />
                <Column field="recruiters_Incentive" header="Recruiters Incentive" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.recruiters_Incentive}`)}</p>} />
                <Column field="recruiters_Revenues" header="Recruiters Revenues" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.recruiters_Revenues}`)}</p>} />
                <Column field="recruiters_Rev_P_L" header="Recruiters R.Profit/Loss" body={(rowData: IRecruiterHeadRevenueReport) => <p style={{ color: ((rowData.recruiters_Rev_P_L || 0) >= 0) ? "green" : "red" }}>₹ {parseInt(`${rowData.recruiters_Rev_P_L}`)}</p>} />
                <Column field="projected_Recruiters_Revenues" header="Projected Recruiters Revenues" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.projected_Recruiters_Revenues}`)}</p>} />
                <Column field="projected_Recruiters_Incentive" header="Projected Recruiters Incentive" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.projected_Recruiters_Incentive}`)}</p>} />
                <Column field="projected_Recruiters_Monthly_CTC" header="Projected Recruiters Monthly CTC" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.projected_Recruiters_Monthly_CTC}`)}</p>} />
                <Column field="projected_Recruiters_Seating_Cost" header="Projected Recruiters Seating Cost" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.projected_Recruiters_Seating_Cost}`)}</p>} />
                <Column field="recruiters_Proj_Rev_P_L" header="Recruiters Proj Rev P/L" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.recruiters_Proj_Rev_P_L}`)}</p>} />
                <Column field="rating" header="Rating" headerStyle={{ minWidth: "12rem" }} bodyStyle={{ minWidth: "12rem" }} body={(rowData: IRecruiterHeadRevenueReport) => <Rating rev={(rowData.recruiters_Revenues || 0)} exp={((rowData.recruiters_Monthly_CTC || 0) + (rowData.recruiters_Seating_Cost || 0) + (rowData.recruiters_Incentive || 0))} />} />
                {/* <Column field="monthly_CTC" header="Monthly CTC" body={(rowData: IRecruiterHeadRevenueReport) => <p>₹ {parseInt(`${rowData.monthly_CTC}`)}</p>} /> */}
                {/* <Column field="" header="R P/L" body={(rowData: IRecruiterHeadRevenueReport) => <p style={{ color: ((rowData.expenses || 0) < (rowData.revenue || 0)) ? "green" : "red" }}>₹ {(((rowData.revenue || 0) < (rowData.expenses || 0))) ? parseInt(`${(-1 * ((rowData.revenue || 0) - (rowData.expenses || 0)))}`) : parseInt(`${((rowData.revenue || 0) - (rowData.expenses || 0))}`)}</p>} /> */}

                {/* <Column field="projected_Revenue" header="P.Revenue" body={projectRevenue} />
                <Column field="" header="P.R P/L" body={projectRevenuePL} /> */}
                <Column field="" header="Action" />
            </DataTable>
            {/* <ProjectRevenueDetails open={openProjectRevenueDetails.open} hideDialog={() => setOpenProjectRevenueDetails({ open: false, user_Employee_ID: '' })} user_Employee_ID={openProjectRevenueDetails.user_Employee_ID} revenueFilter={revenueFilter} toast={props.toast} /> */}
        </>
    );
}